module.exports = __webpack_public_path__ + "static/media/payment-icon-paypal.a98d2e6d.svg";